<template>
  <div class="home">
    <Header :navListAll="navListAll"></Header>
    <Head></Head>
    <!-- <div><a href="http://oa.univ-bio.com/">回到首页</a></div> -->
    <router-view></router-view>
    <RightNavbar :navListAll="navListAll"></RightNavbar>
    <RightMerge></RightMerge>
  </div>
</template>

<script>
import Header from './Header'
import Head from './Head'
import RightNavbar from './RightNavbar'
import RightMerge from './rightMerge'
export default {
  name: 'Home',
  components:{Head,RightNavbar,Header,RightMerge},
  data () {
    return {
      navListAll:[]
    }
  },
  created(){
    this.getNavlist()
  },
  methods:{
    getNavlist() {
      //导航
      this.$http({
        url: this.$http.adornUrl(`/common/getNavList`),
        method: "get",
      }).then(({ data }) => {
        this.navListAll = data.data
        // let arr = [];
        // for (var i in data.data) {
        //   data.data[i]["name"] = i;
        //   arr.push(data.data[i]);
        // }
        // this.navList = arr;
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.home{
  width: 80%;
  min-width: 1200px;
  margin: auto;
  padding-bottom: 40px;
}

</style>




// WEBPACK FOOTER //
// src/components/Home.vue